import {
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  TwitterLogo,
  YoutubeLogo,
} from "@phosphor-icons/react";
import classes from "../News.module.scss";
import moment from "moment";

const Footer = () => {
  return (
    <div className={classes.footer}>
      <span className="mt-4">© {moment().year()} Riopele Group</span>

      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginRight: "auto",
        }}
      >
        <img
          src="https://mon.riopele.pt/assets/imagens/prr/texpact.png"
          alt="Textp@act"
          style={{ height: "40px", marginLeft: "100px", objectFit: "contain" }}
        />
        <img
          src="https://mon.riopele.pt/assets/imagens/prr/prr-white.png"
          alt="PRR"
          style={{ height: "30px", objectFit: "contain" }}
        />
      </div> */}
      <div>
        <a href="https://www.facebook.com/RIOPELE" target="_blank">
          <FacebookLogo size={20} weight="bold" />
        </a>
        <a href="https://www.linkedin.com/company/riopele" target="_blank">
          <LinkedinLogo size={20} weight="bold" />
        </a>
        <a href="https://www.instagram.com/riopele.pt" target="_blank">
          <InstagramLogo size={20} weight="bold" />
        </a>
        <a href="https://twitter.com/riopele" target="_blank">
          <TwitterLogo size={20} weight="bold" />
        </a>
        <a
          href="https://www.youtube.com/channel/UCf2JdtmzlEc2fVVTXdXe2Nw?cbrd=1"
          target="_blank"
        >
          <YoutubeLogo size={20} weight="bold" />
        </a>
      </div>
    </div>
  );
};

export default Footer;
